import type { KeyboardEvent } from 'react'

const AUTO_INPUT_MS = 300
let lastInputTime = 0

/**
 * 자동 입력 후 Enter 키가 눌렸을 때 시스템적 입력인지 확인하고,
 * 의도치 않게 콜백 함수가 실행되지 않도록 방지하는 함수.
 *
 * AUTO_INPUT_MS(300ms) 미만의 빠른 Enter 입력시 콜백이 호출되지 않음.
 * 모바일 키패드 인증번호 자동완성을 눌렸을때, 특정브라우저(Safari)에서 의도치 않게 발생중
 */
export default function handleAutoInputGuard(
  event: KeyboardEvent<HTMLInputElement>,
  callbackFn: () => void,
) {
  const now = performance.now()

  if (event.key === 'Enter') {
    if (!event.nativeEvent.isTrusted) return // 사용자 입력이 아닌경우 리턴

    const timeSinceLastInput = now - lastInputTime
    if (timeSinceLastInput < AUTO_INPUT_MS) return
    callbackFn()
    return
  }

  lastInputTime = now
}
